import React from "react";

export const Section = ({ title, children, testId }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-5" data-testid={testId}>
    <h3 className="text-sm font-semibold text-gray-800 mb-3">{title}</h3>
    {children}
  </div>
);
